export const GAME_CARD_ID_PREFIX = 'game-card-';

export const NUMBERED_GAMES_TYPE = 'numberedGames';

export const CAROUSEL_GAMES_TYPE = 'carousel';

/**
 * How long the row takes to travel one card, drifting continuously rather than resting on any of
 * them. Expressed as time per card rather than a speed so the cadence is identical on web and
 * mobile, and stays put if the tile size ever changes.
 *
 * Provisional — design owns the final motion spec.
 */
export const CAROUSEL_CARD_TRAVEL_MS = 5000;

/** How long an arrow's one-card nudge takes before the drift picks up again. */
export const CAROUSEL_STEP_MS = 600;

/**
 * Coverflow geometry, measured off the Figma desktop frame (a 168.6px card is the 1.0 tile).
 *
 * The focal card is 1.17 of a tile and each card out shrinks to 1.11, 1.05 and then 1.0, where it
 * stops. Stops are read at whole card-steps from the centre and interpolated between, so a card
 * grows smoothly as it travels in.
 */
export const CAROUSEL_SCALE_STOPS = [1.17, 1.11, 1.05, 1, 1];

/**
 * Where a card's centre is painted, in tile widths from the focal card, at 0..4 steps out. The
 * design packs the outer cards tighter than the layout's fixed stride does (0.8, 1.59, 2.25, 2.75
 * against 0.9 a step), so `paint` shifts each card to this curve. Past the last stop it carries on
 * at the last segment's pace.
 */
export const CAROUSEL_OFFSET_STOPS = [0, 0.8, 1.59, 2.25, 2.75];

/** Layout spacing of card centres, as a share of a card-width. Painted spacing is CAROUSEL_OFFSET_STOPS. */
export const CAROUSEL_STRIDE_RATIO = 0.9;

/** Black overlay opacity at 0, 1, 2 and 3 cards from the centre, as in the design. */
export const CAROUSEL_DIM_STOPS = [0, 0.4, 0.6, 0.8];

/**
 * A category with fewer games than this shows 7 cards (the focal card and three each side) rather
 * than 9: a 9-wide row of a short list would show the same game on both sides of itself.
 */
export const CAROUSEL_COMPACT_BELOW_GAMES = 10;

/** Cards out from the centre that stay visible in a compact row; the next 0.6 of a step fades them out. */
export const CAROUSEL_COMPACT_VISIBLE_STEPS = 3;
export const CAROUSEL_COMPACT_FADE_STEPS = 0.6;

/** How long auto-scroll stays paused after the player drags, swipes or clicks an arrow. */
export const CAROUSEL_RESUME_DELAY_MS = 3000;

/**
 * How many cards of the loaded list the player may still have in front of them when the next page
 * is requested — at CAROUSEL_CARD_TRAVEL_MS a card, about 40s for the request to land.
 */
export const CAROUSEL_LOAD_AHEAD_CARDS = 8;

/** How long a carousel waits before asking for a page again after a request that did not land. */
export const CAROUSEL_LOAD_RETRY_MS = 5000;

/** Past this many loaded games only the player's own scrolling pulls more, so an idle lobby stops paging. */
export const CAROUSEL_AUTO_LOAD_MAX_GAMES = 100;
